/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { ACTION_TYPES, getPriceStr, toTitleCase } from "./newhomesutils"

const NewhomeSeoResults = ({ description, lang, meta, title, searchParams, location }) => {

  const {areas, bedrooms, pType, type, price, commType, mustInclude } = searchParams;

  const actionStr = ACTION_TYPES[pType];
  const priceStr = getPriceStr(price)
  const bedRooms = searchParams.bedrooms

  const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  let propertyType = ""

  if(type == "") {
    propertyType = "new homes"
  } else if(type == "apartment") {
    propertyType = "new apartments"
  } else if(type == "house") {
    propertyType = "new houses"
  } else if(type == "new-home") {
    propertyType = "New homes"
  } else if(type == "bungalow") {
    propertyType = "new bungalows"
  } else if(type == "detached-house") {
    propertyType = "Detached houses"
  } else if(type == "semi-detached-house") {
    propertyType = "New semi detached houses"
  } else if(type == "terrace") {
    propertyType = "New terraced houses"
  } else {
    propertyType = "new " + (type.replace(/-/g, ' '))
  }

  let mustIncludeTitle = ""

  if ( mustInclude ) {
    mustIncludeTitle = " with "+mustInclude.join(' and ').replace("parking", "Parking").replace("chain", "Chain").replace("outside", "Outside").replace(/-/g, ' ')
  }


  let desc = "";

    let titlePropertyType = ""

    if (type == "") {
      titlePropertyType = ` New homes  `;
      // titlePropertyType = `New ${capitalize(type)} `;
    } else if(type == "apartment") {
      titlePropertyType = "New apartments"
    } else if(type == "house") {
        titlePropertyType = "New houses"
    } else if(type == "bungalow") {
        titlePropertyType = "New bungalows"
    } else if(type == "new-home") {
      titlePropertyType = "New homes"
    } else if(type == "detached-house") {
      titlePropertyType = "Detached houses"
    } else if(type == "semi-detached-house") {
      titlePropertyType = "New semi detached houses"
    } else if(type == "terrace") {
      titlePropertyType = "New terraced houses"
    } else {
      titlePropertyType = `New ${(type)} `;
    }

    let bedroomType = ""
    let bedroomTypeDesc = ""

    if ( bedrooms ) {
      if(bedrooms > 1){
        bedroomType = " with more than "+bedrooms+" bedrooms";
        bedroomTypeDesc = bedrooms+" bedrooms";
      }else{
        bedroomType = " with more than "+bedrooms+" bedroom";
        bedroomTypeDesc = bedrooms+" bedroom";
      }
    }

    let descTitle = (titlePropertyType.replace(/-/g, ' ')) + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + priceStr + mustIncludeTitle.toLowerCase()

  desc  = "Looking for "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +"? Try Martyn Gerrard. Our experts help you with all your property needs.."

  if (bedrooms) {
    desc = "Discover "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType+". Our experts are specialise in "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +", contact us today for more information.";
  }
  if (priceStr) {
    desc = "Check out the latest collections of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr+". Our property experts are here to help you find the right property."
  }
  if(propertyType != "new homes"){
    desc = "Discover the wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +", contact us for any information about the "+ propertyType + " in "+ toTitleCase(areas.replace(/-/g, ' '))+"."
  }
  if(mustInclude){
    desc = "Find the wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle.toLowerCase()+". Contact Martyn Gerrard leading estate agents."
  }
  if (bedrooms && priceStr) {
    desc = "Find "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + priceStr +"? Book a viewing for any interested property.";
  }
  if (bedrooms && propertyType != "new homes") {
    desc = "Explore wide range of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType+". Book an appointment with one of our specialists today to find the perfect "+ propertyType +" in "+ toTitleCase(areas.replace(/-/g, ' ')) +".";
  }
  if (bedrooms && mustInclude) {
    desc = "Check out "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + mustIncludeTitle.toLowerCase()+", contact us today more information about "+ propertyType +" in "+ toTitleCase(areas.replace(/-/g, ' ')) +".";
  }
  if (priceStr && propertyType != "new homes") {
    desc = "Here is the latest collection of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr+" with Martyn Gerrard, Contact us and get assisted for all your property needs.";
  }
  if (priceStr && mustInclude) {
    desc = "Find "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr + mustIncludeTitle.toLowerCase()+" with Martyn Gerrard here, book a viewing for interested property."
  }
  if(propertyType != "new homes" && mustInclude){
    desc = "Find "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + mustIncludeTitle.toLowerCase()+" with Martyn Gerrard, Contact us for more details."
  }
  if(priceStr && bedrooms && mustInclude){
    desc = "Check out "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + bedroomType + priceStr + mustIncludeTitle.toLowerCase()+", our experts help you find the perfect "+ propertyType +" in "+toTitleCase(areas.replace(/-/g, ' '))+".";
  }
  // console.log("Props Desc => ", desc);
  var currentURL = '';
  if (location !== undefined && location.pathname) {
    currentURL = process.env.GATSBY_SITE_URL + location.pathname;
  }

  description = desc

  // set no index for result pagination
  let hasPagination = false;
  if (location !== undefined && location.pathname) {
    let pageStr = location.pathname.split('page-');
    hasPagination = pageStr[1] || false;
    if (pageStr[0] !== undefined) {
     currentURL = process.env.GATSBY_SITE_URL + pageStr[0];
    }
  }

  if (!currentURL.endsWith('/'))
        currentURL = currentURL + '/';

  let metaItems = [
    {
      name: `description`,
      content: description,
    },
    {
      property: `og:title`,
      content: descTitle,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: `Martyn Gerrard`,
    },
    {
      name: `twitter:title`,
      content: descTitle,
    },
    {
      name: `twitter:description`,
      content: description,
    },
  ].concat(meta);


  // set no index for result pagination
  if ( hasPagination ) {
    // metaItems.push({
    //   name: `robots`,
    //   content: `noindex`,
    // })
  }

  if ( currentURL ) {
    metaItems.push({
      name: `og:url`,
      content: currentURL,
    })
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
          {
              href: currentURL,
              rel: "canonical"
          }
      ]}
      title={descTitle}
      titleTemplate={`%s | Martyn Gerrard`}
      meta={metaItems}
    />
  )
}

NewhomeSeoResults.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  title: ``,
  searchParams: [],
}

NewhomeSeoResults.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  searchParams: PropTypes.any,
}

export default NewhomeSeoResults
